



















































































// Vue-related and Decorators
import { Component, Watch } from 'vue-property-decorator';
// Models
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { Project } from '@/models/project';

// Components
import AppliedLessonTable from '@/components/worksheets/AppliedLessonTable.vue';
import ColumnsFilter from '@/components/worksheets/ColumnsFilter.vue';
import FormDynamicFieldMultiselect from '@/components/form/FormDynamicFieldMultiselect.vue';
import XProcessWorksheet from '@/components/projects/fields/XProcessWorksheet.vue';
import ProjectViewFilterPanel from '../filters/ProjectViewFilterPanel.vue';
import WorksheetUpdateLessonModal from '@/components/worksheets/WorksheetUpdateLessonModal.vue';

// Web Services
import { xAppliedLessonWebservice } from '@/webservices/xappliedlesson';

// Helpers, Utilities, and Miscellaneous
import { createAppliedLessonsFilter } from '@/helpers/createAppliedLessonsFilter';
import { AppliedLessonType } from '@/enums/AppliedLessonType';

import ProjectViewListBase from './ProjectViewListBase'; // Update the path accordingly
import { debounce } from 'lodash';
import { showSuccessNotification } from '@/helpers/showSuccessNotification';
import { ResolvedEnum } from '@/helpers/filter/appliedLessons/filterAppliedLessonsResolved';
import { CheckedEnum } from '@/helpers/filter/appliedLessons/filterAppliedLessonsChecked';

@Component({
    name: 'ProjectViewXList',
    components: {
        FormDynamicFieldMultiselect,
        ColumnsFilter,
        XProcessWorksheet,
        AppliedLessonTable,
        WorksheetUpdateLessonModal,
        ProjectViewFilterPanel,
    },
})
export default class ProjectViewXList extends ProjectViewListBase {
    get filteredXProcesses() {
        return this.xProcesses.filter((t) => this.selectedXProcesses.some((st) => st.id === t.id));
    }
    private AppliedLessonType = AppliedLessonType;

    private toggledXProcesses = [];
    private appliedLessonToUpdate: XAppliedLesson = {} as XAppliedLesson;
    private selectedTabs: string[] = ['dynamic'];

    private DEBOUNCE_APPLY_UPDATE_INTERVAL = 0; // milliseconds
    private DEBOUNCE_RELOAD_WORKSHEET_INTERVAL = 10; // milliseconds
    private DEBOUNCE_UPDATE_NOTIFICATION_INTERVAL = 2000; // milliseconds

    private debouncedUpdate = debounce(this.applyUpdate, this.DEBOUNCE_APPLY_UPDATE_INTERVAL);
    private debouncedReload = debounce(this.reloadWorksheet, this.DEBOUNCE_RELOAD_WORKSHEET_INTERVAL);
    private debouncedUpdateNotification = debounce(this.updateNotification, this.DEBOUNCE_UPDATE_NOTIFICATION_INTERVAL);

    private isUpdating: boolean = false;

    mounted() {
        this.resetFilter();
        this.loadPhases();
        this.loadTopics();
    }
    private async applyUpdate(lesson: XAppliedLesson) {
        await xAppliedLessonWebservice.update(lesson as XAppliedLesson).catch(() => {
            this.showErrorNotification('toastMessages.error.worksheet');
        });
        this.debouncedUpdateNotification();
        this.debouncedReload();
    }

    @Watch('project')
    private onProjectChanged(newProject: Project, oldProject: Project | null) {
        if (!oldProject || newProject.id !== oldProject.id) {
            this.resetFilter();
        }
    }

    private resetFilter() {
        this.tableColumns = createAppliedLessonsFilter(this.companySetting);
        this.filterResolved = ResolvedEnum.NotResolved;
        this.filterChecked = CheckedEnum.All;
        if (this.companySetting.feature_dynamic_worksheet_field) {
            this.fetchAllDynamicFields();
            this.selectedDynamicFields = this.dynamicFields;
        }
        this.selectedXProcesses = this.xProcesses;
    }

    private toggleUpdateAppliedLessonModal(value) {
        this.appliedLessonToUpdate = value;
        let worksheet = null;
        for (const xprocess of this.project.xprocesses as any[]) {
            if (xprocess.worksheet && xprocess.worksheet.id === value.pm_worksheet_id) {
                worksheet = xprocess.worksheet;
                break;
            }
        }
        this.toggleModal(WorksheetUpdateLessonModal, {
            type: AppliedLessonType.XAppliedLesson,
            worksheet,
            saved: this.refreshSelectedProject,
            appliedLessonToUpdate: this.appliedLessonToUpdate,
        });
    }

    private updateNotification() {
        showSuccessNotification('toastMessages.update.worksheet');
    }
    // Apply accumulated updates
    private async reloadWorksheet() {
        this.isUpdating = true;
        await this.refreshSelectedProject();
        this.isUpdating = false;
    }
}
